import GetShopOrderItemListRequestModelBase from '../_generated/modelBases/get-shop-order-item-list-request-model-base';

export default class GetShopOrderItemListRequestModel extends GetShopOrderItemListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
